import { render, staticRenderFns } from "./StockDetailBuy.vue?vue&type=template&id=b91e4b74&scoped=true&"
import script from "./StockDetailBuy.vue?vue&type=script&lang=js&"
export * from "./StockDetailBuy.vue?vue&type=script&lang=js&"
import style0 from "./StockDetailBuy.vue?vue&type=style&index=0&id=b91e4b74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91e4b74",
  null
  
)

export default component.exports